
/* -----------------------------------------------------------------------------------------------------
  - Created: [20-02-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains the Employee Report search filter component
------------------------------------------------------------------------------------------------------- */

import Grid from '@mui/material/Grid2';
import { useFormik } from 'formik';
import '../../ReportsCommonStyles/CommonSearchFilterStyle.css';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import CustomDatePicker from '../../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import dayjs from 'dayjs';
import ActionButtonWithIcon from '../../../../Components/custom_components/CustomButtons/ActionButtonWithIcon/ActionBtnWithIcon';
import { Icons } from '../../../../utils/GlobalIcons';

function EmployeeUtilizationFilter({
  tableTitle,
  searchFilter,
  on_change_value, on_page_count_update,
  onExportPDF,
  onExportExcel,
  isExportingPDF,
  isExportingExcel
}) {


  const formik = useFormik({
    initialValues: {
      employee_name: '',
      start_date: "",
      end_date: "",
    },
    onSubmit: values => {
      searchFilter(values);
    },
  });

  const resetFilter = () => {
    on_change_value(1)
    on_page_count_update(25)
    formik.resetForm();
    searchFilter({
      employee_name: '',
      start_date: "",
      end_date: "",
      // worksite: '',
    });
  };
  const breadcrumbs = ["Reports", "Employee  Utilization Report"];
  return (
    <div className="common-search-filter-container">
      <div className="common-search-filter-sub-container">
        <div className="common-search-header">
          <div className="common-search-left">
            <div className="common-table-title">{tableTitle}</div>
            <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
          </div>
          <div className="common-export-buttons-container">
            <ActionButtonWithIcon
              label="Export PDF"
              onClick={onExportPDF}
              icon={Icons.PdfIcon}
              backgroundColor="#ffffff"
              hoverColor="#fef2f2"
              labelColor="#000000"
              borderColor="#e5e7eb"
              iconColor="#dc2626"
              loading={isExportingPDF}
            />

            <ActionButtonWithIcon
              label="Export Excel"
              onClick={onExportExcel}
              icon={Icons.ExcelIcon}
              backgroundColor="#ffffff"
              hoverColor="#f0fdf4"
              labelColor="#000000"
              borderColor="#e5e7eb"
              iconColor="#16a34a"
              loading={isExportingExcel}
            />
          </div>
        </div>

        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <CustomTextFieldWithIcon
              id="employee_name"
              name="employee_name"
              placeholder="Search by Employee Name"
              value={formik.values.employee_name}
              onChange={formik.handleChange}
              width="200px"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <CustomDatePicker
              name="start_date"
              label="From Date"
              onChange={(date) => {
                formik.setFieldValue("start_date", date);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.start_date ? dayjs(formik.values.start_date, "DD-MM-YYYY") : null}
              width="200px"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <CustomDatePicker
              name="end_date"
              label="End Date"
              onChange={(date) => {
                formik.setFieldValue("end_date", date);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.end_date ? dayjs(formik.values.end_date, "DD-MM-YYYY") : null}
              minDate={dayjs(formik.values.start_date, "DD-MM-YYYY")} // Set minimum date
              width="200px"
            />
          </Grid>

          <Grid item xs={12} sm={12} md={3}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <ActionButton
                  onClick={() => {
                    on_change_value(1)
                    searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                  }}
                  btnDisable={false}
                  label="Search"
                  btnType="primary"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <ActionButton
                  onClick={resetFilter}
                  label="Reset"
                  btnType="outlined"
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default EmployeeUtilizationFilter;